/**
 * @generated SignedSource<<158ea0f6d6979a3fd9b6682d78cd4e9c>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceContentSearchScope {
  PAGE = "PAGE",
  BLOGPOST = "BLOGPOST",
  ATTACHMENT = "ATTACHMENT",
  SPACE = "SPACE",
  WHITEBOARD = "WHITEBOARD",
  DATABASE = "DATABASE",
  EMBED = "EMBED",
  FOLDER = "FOLDER",
}
export interface ConfluenceContentSortField {
  field: ConfluenceContentSortingParameter;
  key?: InputMaybe<Scalars["String"]["input"]>;
  order: SortOrder;
}
export enum ConfluenceContentSortingParameter {
  LAST_MODIFIED_DATE = "LAST_MODIFIED_DATE",
  TITLE = "TITLE",
}
export enum ConfluenceSearchContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DRAFT = "DRAFT",
}
export interface ConfluenceSearchContributorFilter {
  accountIds: Array<Scalars["ID"]["input"]>;
}
export interface ConfluenceSearchFilters {
  spaces?: InputMaybe<ConfluenceSearchSpaceFilter>;
  contributors?: InputMaybe<ConfluenceSearchContributorFilter>;
  labels?: InputMaybe<Array<ConfluenceSearchLabelFilter>>;
  lastModified?: InputMaybe<ConfluenceSearchLastModifiedFilter>;
  statuses?: InputMaybe<ConfluenceSearchStatusesFilter>;
  titleMatchOnly?: InputMaybe<ConfluenceSearchTitleMatchOnlyFilter>;
}
export interface ConfluenceSearchLabelFilter {
  name: Scalars["String"]["input"];
  namespace?: InputMaybe<LabelNamespaceEnum>;
}
export interface ConfluenceSearchLastModifiedFilter {
  from: Scalars["String"]["input"];
  to: Scalars["String"]["input"];
}
export interface ConfluenceSearchSpaceFilter {
  spaceKeys: Array<Scalars["String"]["input"]>;
}
export interface ConfluenceSearchStatusesFilter {
  statuses: Array<ConfluenceSearchContentStatus>;
}
export interface ConfluenceSearchTitleMatchOnlyFilter {
  titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
}
export enum LabelNamespaceEnum {
  GLOBAL = "GLOBAL",
  MY = "MY",
  TEAM = "TEAM",
}
export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space_currentUser_SpaceUserMetadata =
  {
    __typename?: "SpaceUserMetadata";
    isWatched: boolean;
    isWatchingBlogs: boolean;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    key: string | null;
    currentUser: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space_currentUser_SpaceUserMetadata;
    operations: Array<SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space_operations_OperationCheckResult | null> | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    currentUserIsWatching: boolean;
    type: string | null;
    space: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content_space_Space | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_lastModified_Date =
  {
    __typename?: "Date";
    value: string;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    editui: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_emoji_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_editorVersion_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy =

    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_Anonymous
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_KnownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_UnknownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy_User;
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy =

    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_Anonymous
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_KnownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_UnknownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy_User;
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History =
  {
    __typename?: "History";
    createdBy: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_createdBy | null;
    ownedBy: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History_ownedBy | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary =
  {
    __typename?: "FavouritedSummary";
    isFavourite: boolean | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser =
  {
    __typename?: "ContentMetadata_CurrentUserMetadataProvider_currentuser";
    favourited: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_comments_ContentMetadata_CommentsMetadataProvider_comments =
  {
    __typename?: "ContentMetadata_CommentsMetadataProvider_comments";
    commentsCount: number | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata =
  {
    __typename?: "ContentMetadata";
    currentuser: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser | null;
    comments: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata_comments_ContentMetadata_CommentsMetadataProvider_comments | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_likes_LikesResponse =
  {
    __typename?: "LikesResponse";
    count: number | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by =

    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_Anonymous
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_KnownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_UnknownUser
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by_User;
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version =
  {
    __typename?: "Version";
    by: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version_by | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content =
  {
    __typename?: "Content";
    id: string | null;
    type: string | null;
    subType: string | null;
    status: string | null;
    blank: boolean;
    links: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
    emoji: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_emoji_PaginatedJsonContentPropertyList | null;
    editorVersion: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_editorVersion_PaginatedJsonContentPropertyList | null;
    space: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_space_Space | null;
    history: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_history_History | null;
    metadata: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_metadata_ContentMetadata;
    likes: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_likes_LikesResponse | null;
    version: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content_version_Version | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult =
  {
    __typename?: "ConfluenceContentSearchResult";
    id: string;
    title: string;
    url: string;
    excerpt: string;
    watchDialogContent: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_watchDialogContent_Content | null;
    lastModified: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_lastModified_Date;
    content: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult_content_Content | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceSpaceSearchResult =
  {
    __typename?: "ConfluenceSpaceSearchResult";
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes =

    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceContentSearchResult
    | SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes_ConfluenceSpaceSearchResult;
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_pageInfo_XpsPageInfo =
  {
    __typename?: "XpsPageInfo";
    hasNextPage: boolean;
    nextPageToken: string | null;
  };
export type SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults =
  {
    __typename?: "ConfluenceContentSearchResults";
    totalCount: number;
    nodes: Array<SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_nodes>;
    pageInfo: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults_pageInfo_XpsPageInfo;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    editui: string | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_emoji_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_editorVersion_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    key: string | null;
    alias: string | null;
    name: string | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy =

    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_Anonymous
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_KnownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_UnknownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy_User;
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy =

    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_Anonymous
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_KnownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_UnknownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy_User;
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History =
  {
    __typename?: "History";
    createdBy: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_createdBy | null;
    ownedBy: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History_ownedBy | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary =
  {
    __typename?: "FavouritedSummary";
    isFavourite: boolean | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser =
  {
    __typename?: "ContentMetadata_CurrentUserMetadataProvider_currentuser";
    favourited: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_comments_ContentMetadata_CommentsMetadataProvider_comments =
  {
    __typename?: "ContentMetadata_CommentsMetadataProvider_comments";
    commentsCount: number | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata =
  {
    __typename?: "ContentMetadata";
    lastModifiedDate: string | null;
    currentuser: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser | null;
    comments: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata_comments_ContentMetadata_CommentsMetadataProvider_comments | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_likes_LikesResponse =
  {
    __typename?: "LikesResponse";
    count: number | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
    profilePicture: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous_profilePicture_Icon | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by =

    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_Anonymous
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_KnownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_UnknownUser
    | SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by_User;
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version =
  {
    __typename?: "Version";
    by: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version_by | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content =
  {
    __typename?: "Content";
    id: string | null;
    title: string | null;
    type: string | null;
    subType: string | null;
    status: string | null;
    blank: boolean;
    excerpt: string;
    links: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
    emoji: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_emoji_PaginatedJsonContentPropertyList | null;
    editorVersion: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_editorVersion_PaginatedJsonContentPropertyList | null;
    space: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_space_Space | null;
    history: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_history_History | null;
    metadata: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_metadata_ContentMetadata;
    likes: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_likes_LikesResponse | null;
    version: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content_version_Version | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult =
  {
    __typename?: "CollaborationGraphRecommendationResult";
    id: string;
    content: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult_content_Content | null;
  };
export type SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults =
  {
    __typename?: "CollaborationGraphRecommendationResults";
    nodes: Array<SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults_nodes_CollaborationGraphRecommendationResult>;
  };
export type SpacePagesQuery_Query = {
  __typename?: "Query";
  confluenceContentSearch: SpacePagesQuery_confluenceContentSearch_ConfluenceContentSearchResults;
  objectRecommendations?: SpacePagesQuery_objectRecommendations_CollaborationGraphRecommendationResults;
};
export type SpacePagesQueryVariables = Exact<{
  searchText: Scalars["String"]["input"];
  filters: ConfluenceSearchFilters;
  first: Scalars["Int"]["input"];
  maxNumberOfResults: Scalars["Int"]["input"];
  token?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<
    Array<ConfluenceContentSortField> | ConfluenceContentSortField
  >;
  isLicensed: Scalars["Boolean"]["input"];
  includeRecommended?: InputMaybe<Scalars["Boolean"]["input"]>;
  spaceId?: InputMaybe<Scalars["String"]["input"]>;
  scopes: Array<ConfluenceContentSearchScope> | ConfluenceContentSearchScope;
}>;
export type SpacePagesQuery = SpacePagesQuery_Query;
